import cn from 'classnames';

import { StatusLegendItem } from './statusColors';

import s from './TimeEstimationScatterChart.module.scss';

type EstimationStatusLegendProps = {
  items: StatusLegendItem[];
};

export const EstimationStatusLegend: React.FC<EstimationStatusLegendProps> = ({ items }) => {
  return (
    <div
      className={cn(s.chart__legend, s.chart__status_legend)}
      data-testid="estimation-status-legend"
    >
      {items.map((item) => (
        <div key={item.statusKey} className={s.chart__legend_item}>
          <span className={s.chart__legend_dot} style={{ background: item.color }} />
          <span>
            {item.label}: {item.count}
          </span>
        </div>
      ))}
    </div>
  );
};
